import * as actionTypes from '../constants/index'

const theme = (type = "default", action) => {
    switch (action.type) {
        case actionTypes.set_theme:
            return action.data || "default";
        default:
            return type
    }
};

export  {theme}